import { createSlice } from "@reduxjs/toolkit";

// Initial state for the Revenue Report
const initialState = {
  activeReport: "Service-wise Revenue",
  fromDate: "",
  toDate: "",
  filter: "This filtered period Lead",
  reportType: "Analytics",
  reportData: {
    "Service-wise Revenue": {
      labels: ["Service A", "Service B", "Service C", "Service D", "Service E"],
      datasets: [
        {
          label: "Revenue",
          backgroundColor: "#60a5fa",
          data: [5000, 7000, 4000, 8000, 6000],
        },
      ],
    },
    "Month-wise Revenue": {
      labels: ["January", "February", "March", "April", "May"],
      datasets: [
        {
          label: "Revenue",
          backgroundColor: "#34a1eb",
          data: [10000, 12000, 9000, 15000, 11000],
        },
      ],
    },
    "Country-wise Revenue": {
      labels: ["USA", "UK", "Canada", "Australia", "India"],
      datasets: [
        {
          label: "Revenue",
          backgroundColor: "#ec4899",
          data: [25000, 20000, 15000, 30000, 18000],
        },
      ],
    },
    "Level of Study-wise Revenue": {
      labels: ["Undergraduate", "Transfer", "Masters", "MBA", "PHD"],
      datasets: [
        {
          label: "Revenue",
          backgroundColor: "#86efac",
          data: [5000, 2000, 8000, 10000, 4000],
        },
      ],
    },
    "Total Revenue": {
      labels: ["2025", "2026", "2027", "2028"],
      datasets: [
        {
          label: "Yearly Revenue",
          backgroundColor: "#facc15",
          data: [150000, 200000, 250000, 300000],
        },
        {
          label: "Monthly Revenue",
          backgroundColor: "#3b82f6",
          data: [12000, 14000, 13000, 16000],
        },
      ],
    },
  },
};

const revenueReportSlice = createSlice({
  name: "revenueReport",
  initialState,
  reducers: {
    setActiveReport: (state, action) => {
      state.activeReport = action.payload;
    },
    setFromDate: (state, action) => {
      state.fromDate = action.payload;
    },
    setToDate: (state, action) => {
      state.toDate = action.payload;
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
    setReportType: (state, action) => {
      state.reportType = action.payload;
    },
    setReportData: (state, action) => {
      state.reportData = action.payload;
    },
  },
});

export const {
  setActiveReport,
  setFromDate,
  setToDate,
  setFilter,
  setReportType,
  setReportData,
} = revenueReportSlice.actions;

export default revenueReportSlice.reducer;
